/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-13 14:40:20
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-14 11:17:04
 * @FilePath: /chaoyongtuan/src/components/business/sampleFreeBroadcastDrawer/components/confirmCooGoods/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

const goodsInfo = {
	label: '商品信息',
	type: () => import('./components/goodsBox'),
	isShow: true,
	minWidth: '280',
};

export const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '50',
};
export default [goodsInfo];
